import { render, staticRenderFns } from "./visitnum.vue?vue&type=template&id=2b7cc542&scoped=true&"
import script from "./visitnum.vue?vue&type=script&lang=js&"
export * from "./visitnum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7cc542",
  null
  
)

export default component.exports